<template>
  <log-new v-if="logNewParams.length>0" :params="logNewParams"/>
</template>

<script>
import LogNew from "@/views/Log/LogNew.vue";

export default {
  components: {LogNew},
  props: [
    //old
    'entityName',
    'entityId',
    'parentEntityName',
    'parentEntityId',
    'small',
    'logClass',
  ],
  data: () => ({
    logNewParams: [],
  }),
  mounted() {
    this.logNewOpen();
  },
  watch:{
    entityName(){this.logNewOpen()},
    entityId(){this.logNewOpen()},
    parentEntityName(){this.logNewOpen()},
    parentEntityId(){this.logNewOpen()},
  },
  methods:{
    logNewOpen(){
      let logNewParams = [];
      if(!this.$tools.isEmpty(this.entityName) && !this.$tools.isEmpty(this.entityId)) logNewParams.push([this.entityName,this.entityId])
      if(!this.$tools.isEmpty(this.parentEntityName) && !this.$tools.isEmpty(this.parentEntityId)) logNewParams.push([this.parentEntityName,this.parentEntityId])
      if(logNewParams.length>0)
        this.logNewParams = logNewParams;
    }
  }
}
</script>
